import { Divider, styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.65rem 2rem',
  borderRadius: '0.5rem',
  gap: '0.5rem',
  transition: '0.3s',
  cursor: 'pointer',
  userSelect: 'none',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const FixedElements = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-0.188rem',
  zIndex: 10,
  backgroundColor: theme.palette.primary.main,
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.details.light,
  opacity: 0.5,
  margin: '0 1rem',
}));
